import defaultTheme from './defaultTheme';
const onepaywalmartTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#34657f', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#34657f', background: '#34657f' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#34657f' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#34657f', border: '#34657f', background: '#34657f' }), field: {
        focus: '#34657f',
        label: '#34657f',
        icon: '#34657f',
    } });
export default onepaywalmartTheme;
